/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 3/18/2017
 * Copyright All Rights Reserved
 */

import {
  REQUEST_TOKEN,
  REQUEST_TOKEN_SUCCESS,
  REQUEST_TOKEN_FAILURE,
  DESTROY_TOKEN,
} from 'constants/actionTypes';

import config from '../support/config';
import apiBaseUrl from 'support/apiBaseUrl';

const axios = require('axios');

function requestToken(email, password) {
  return {
    type: REQUEST_TOKEN,
    email,
    password,
  };
}

function requestTokenSuccess(token, userId) {
  return {
    type: REQUEST_TOKEN_SUCCESS,
    token,
    userId,
  };
}

function requestTokenFailure(error) {
  return {
    type: REQUEST_TOKEN_FAILURE,
    error,
  };
}

export const destroyToken = () => ({
  type: DESTROY_TOKEN,
});

export const fetchToken = (body = {}) => (dispatch) => {
  dispatch(requestToken(body.email, body.password));
  axios.defaults.baseURL = apiBaseUrl(config);
  return axios.post('/users/login', {
    email: body.email,
    password: body.password,
  }).then((response) => {
    axios.defaults.headers.post.Authorization = `bearer ${response.data.token}`;
    axios.defaults.headers.common.Authorization = `bearer ${response.data.token}`;
    dispatch(requestTokenSuccess(response.data.token, response.data.userId));
  })
  .catch((error) => {
    dispatch(requestTokenFailure(error));
  });
};
